import React, { useEffect, useState, createContext, useContext } from 'react';
type Lang = 'en' | 'zh';
interface LanguageContextType {
  lang: Lang;
  setLang: (l: Lang) => void;
}
const LanguageContext = createContext<LanguageContextType>({
  lang: 'en',
  setLang: () => {}
});
export function LanguageProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [lang, setLangState] = useState<Lang>(() => {
    try {
      const stored = localStorage.getItem('wai-lang');
      if (stored === 'zh' || stored === 'en') return stored;
    } catch {}
    return 'en';
  });
  const setLang = (l: Lang) => {
    setLangState(l);
    try {
      localStorage.setItem('wai-lang', l);
    } catch {}
  };
  return <LanguageContext.Provider value={{
    lang,
    setLang
  }} data-id="element-409">
      {children}
    </LanguageContext.Provider>;
}
export function useLanguage() {
  return useContext(LanguageContext);
}